<wiz-vgroup verticalAlign="start" horizontalAlign="start" width="100%" height="100%" class="section-container">
  <wiz-vgroup width="100%">
    <wiz-label #lblUser></wiz-label>
    <wiz-button #btnclearCache width="100%" [wizIcon]="'delete'" 
    [wizLabel]="'$.common.clear.cache.$'" 
    (wizClick)="doAction($event)"></wiz-button>
    <wiz-button #btnRefresh width="100%" [wizIcon]="'undo'" 
    [wizLabel]="'$.common.refresh.cache.$'" 
    (wizClick)="doAction($event)"></wiz-button>
    <wiz-button #btnClearContext width="100%" [wizIcon]="'delete'" 
    [wizLabel]="'$.common.clear.context.$'" 
    (wizClick)="doAction($event)"></wiz-button>
    <!-- <wiz-button #btnKillWorker width="100%" [wizIcon]="'delete'" 
    [wizLabel]="'kill workers'" 
    (wizClick)="doAction($event)"></wiz-button> -->
  </wiz-vgroup>
</wiz-vgroup>
